import * as React from 'react';
import { Row } from 'components/row/Row';

import s from './OneColumn.scss';

interface IOneColumnProps {
  isColumnLayout?: boolean;
  children?: React.ReactNode;
}

interface IContentProps {
  children?: React.ReactNode;
}

export const OneColumn = ({ children, isColumnLayout = true }: IOneColumnProps) => {

  return (
    <div className={s('oneColumn', { offset: !isColumnLayout })}>
      <Row>{children}</Row>
    </div>
  );
};

export const Content = ({ children }: IContentProps) => (
  <div className={s.oneColumn__content}>{children}</div>
);
